export function isSafariOrIOSBrowser() {
    var ua = navigator.userAgent;
    var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    var isIOS = /iPad|iPhone|iPod/.test(ua);
    // eslint-disable-next-line compat/compat
    var isIpadOS = ua.includes('Macintosh') && ('maxTouchPoints' in navigator ? navigator.maxTouchPoints > 1 : false);
    return isSafari || isIOS || isIpadOS;
}
function sendOffsetToParent(_a) {
    var selector = _a.selector, _b = _a.block, block = _b === void 0 ? 'start' : _b;
    var target = document.querySelector(selector);
    if (!target)
        return;
    var rect = target.getBoundingClientRect();
    var offsetTop = window.scrollY + rect.top;
    var postData = JSON.stringify({
        type: 'safariOrIOSOffset',
        offsetTop: offsetTop,
        block: block,
    });
    window.parent.postMessage(postData, '*');
}
export function handleSafariOrIOSOffset(params) {
    if (isSafariOrIOSBrowser()) {
        sendOffsetToParent(params);
    }
}
